// Auto-dismiss flash notifications after 5 seconds
export default {
  mounted() {
    this.timer = setTimeout(() => {
      this.el.style.transition = "opacity 300ms ease-in"
      this.el.style.opacity = "0"
      setTimeout(() => {
        this.el.style.display = "none"
        const key = this.el.dataset.flashKey
        this.pushEvent("lv:clear-flash", key ? { key } : {})
      }, 300)
    }, 5000)
  },
  destroyed() {
    if (this.timer) clearTimeout(this.timer)
  }
}
